import React from 'react';
import {Table} from "react-materialize";

const ReconciledTransactions = () => {
  return (
    <div className={'content-container'}>
      <Table striped>
        <thead>
        <tr>
          <th data-field='date'>
            Date
          </th>
          <th data-field='type'>
            Type
          </th>
          <th data-field='sent-quantity'>
            Sent Quantity
          </th>
          <th data-field='received-quantity'>
            Received Quantity
          </th>
          <th data-field='fee'>
            Fee
          </th>
          <th data-field='source'>
            Source
          </th>
          <th data-field='transaction-id'>
            Transaction ID
          </th>
          <th data-field='Counterparty'>
            Counterparty
          </th>
        </tr>
        </thead>

        <tbody>
        <tr>
          <td>3/22/2020</td>
          <td>Loan</td>
          <td></td>
          <td>750 BCC</td>
          <td>0.00000378</td>
          <td>Torch</td>
          <td>93432442420dc</td>
          <td>Profluent</td>
        </tr>
        </tbody>
      </Table>
    </div>
  )
}

export default ReconciledTransactions;